import React from 'react';
import PropTypes from 'prop-types'
import {makeStyles} from '@material-ui/core';
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Hidden from "@material-ui/core/Hidden";

const useStyles = makeStyles(theme => ({
    paper: {
        maxWidth: 900,
        marginRight: 'auto',
        marginLeft: 'auto',
        padding: '50px 100px',
        [theme.breakpoints.only('xs')]: {
            padding: '25px 5%',
        },
        borderRadius: 20
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 50,
        [theme.breakpoints.down('sm')]: {
            marginBottom: 0
        },
    },
    title: {
        [theme.breakpoints.down('sm')]: {
            fontSize: 18,
        },
    },
    imgTitle: {
        width: 45,
        marginRight: 20,
        [theme.breakpoints.down('sm')]: {
            width: 30,
        },
    },
    bar: {
        border: '1px solid #000000',
        flexGrow: 1,
        marginLeft: 20
    },
    barSmall: {
        border: '1px solid #000000',
        flexGrow: 1,
        marginBottom: 20,
        marginTop: 10,
        [theme.breakpoints.only('sm')]: {
            marginTop: 20,
        },
    },
}));

function PaperCustom({title, src, alt, children}){
    const classes = useStyles();

    return (
        <Paper elevation={5} className={classes.paper}>
            <div className={classes.titleContainer}>
                <img src={src} alt={alt} className={classes.imgTitle}/>
                <Typography component={"h1"} variant={"h1"} className={classes.title}>
                    {title}
                </Typography>
                <Hidden only={['xs','sm']}>
                    <div className={classes.bar}/>
                </Hidden>
            </div>
            <Hidden only={['md','lg','xl']}>
                <div className={classes.barSmall}/>
            </Hidden>
            {children}
        </Paper>
    )
}

PaperCustom.propTypes = {
    title: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
};

export default PaperCustom